import { createAsyncThunk } from '@reduxjs/toolkit';
import { apiClient } from '../../utils/axiosAdvanced';
import { toast } from "react-toastify";

export const getWorkingAddress = createAsyncThunk(
    'googleRouteMaker/getWorkingAddress',
    async ({ searchParam }, thunkAPI) => {
        try {
            const { lat, lng } = searchParam;
            const apiData = await apiClient.post('/get_address', { 'lat': lat, 'lng': lng });
            //console.log("Working address api", apiData.data);
            return { address: apiData.data };
        } catch (error) {
            //console.log("Search events multi error", error);
            return thunkAPI.rejectWithValue(error);
        }
    }
);


export const saveGoogleRoute = createAsyncThunk(
    'route/saveGoogleRoute',
    async (routeObject, thunkAPI) => {
        //console.log("Save google route", routeName, routeDistance, routeTime, routePath, startPoint, endPoint, viaPoints, builtFrom);
        try {
            const apiData = await apiClient.post('/create_route', routeObject);
            //console.log("Save google route api", apiData.data);
            toast.success("Route created successfully")
            return { route: apiData.data.route, message: apiData.data.message, routeList: apiData.data.routeList };
        } catch (error) {
            //console.log("Save google route error", error);
            return thunkAPI.rejectWithValue(error);
        }
    }
);

export const getRouteList = createAsyncThunk(
    'route/getRouteList',
    async (thunkAPI) => {
        const apiData = await apiClient.get('/get_route_list');
        return { routeList: apiData.data.routeList };
    }
);

export const getPaginatedRouteList = createAsyncThunk(
    'route/getPaginatedRouteList',
    async ({ limit = 10, offset = 0 }, thunkAPI) => {
        try {
            const apiData = await apiClient.post('/paginated_route_list', {
                limit: parseInt(limit),
                offset: parseInt(offset)
            });

            return {
                routeList: apiData.data.routeList,
                pagination: apiData.data.pagination
            };
        } catch (error) {
            return thunkAPI.rejectWithValue(error);
        }
    }
);
/*
router.post('/search_routes', async (req, res) => {
    try {
        const ilogistekUserId = req.user_id;
        const { searchQuery, limit = 10, offset = 0 } = req.body;

        ....
    res.status(200).json({
            success: true,
            routeList: routes,
            searchQuery: searchQuery,
            pagination: {
                total: totalCount,
                limit: parsedLimit,
                offset: parsedOffset,
                hasMore: parsedOffset + routes.length < totalCount,
                currentPage: Math.floor(parsedOffset / parsedLimit) + 1,
                totalPages: Math.ceil(totalCount / parsedLimit)
            }
        });
*/

export const searchRoutes = createAsyncThunk(
    'route/searchRoutes',
    async ({ searchQuery, limit = 10, offset = 0 }, thunkAPI) => {
        try {
            const apiData = await apiClient.post('/search_routes', { searchQuery, limit, offset });
            console.log("searchRoutes apiData", apiData.data);
            return {
                routeList: apiData.data.routeList,
                searchQuery: apiData.data.searchQuery,
                pagination: apiData.data.pagination
            };
        } catch (error) {
            return thunkAPI.rejectWithValue(error);
        }
    }
);


export const getOneRoute = createAsyncThunk(
    'route/getOneRoute',
    async ({ routeName, routeNumber }, thunkAPI) => {
        try {
            const apiData = await apiClient.post('/get_one_route', { 'routeName': routeName, 'routeNumber': routeNumber });
            console.log("getOneRoute apiData", apiData.data);
            return { route: apiData.data.data };
        } catch (error) {
            return thunkAPI.rejectWithValue(error);
        }
    }
);

export const getLatestRoute = createAsyncThunk(
    'route/getLatestRoute',
    async (thunkAPI) => {
        try {
            const apiData = await apiClient.get('/get_latest_route');
            return { route: apiData.data.data };
        } catch (error) {
            return thunkAPI.rejectWithValue(error);
        }
    }
);

export const getVehicleLocation = createAsyncThunk(
    'route/getVehicleLocation',
    async ({ assetId, timestamp, type = 'now' }, thunkAPI) => {
        try {
            const apiData = await apiClient.post('/get_vehicle_location', { 'imei': assetId, 'timestamp': timestamp, 'type': type });
            //console.log("Vehicle location api", apiData.data);
            if (apiData.data.success) {
                return { vehicleLocation: apiData.data.location };
            } else {
                return thunkAPI.rejectWithValue(apiData.data.error);
            }
        } catch (error) {
            //console.log("Vehicle location error", error);
            return thunkAPI.rejectWithValue(error);
        }
    }
);


/*
router.post('/deactivate_route', async (req, res) => {
    try {
        const { _id } = req.body;
*/

export const deactivateRoute = createAsyncThunk(
    'route/deactivateRoute',
    async ({ routeId }, thunkAPI) => {
        try {
            const apiData = await apiClient.post('/deactivate_route', { '_id': routeId });
            //console.log("Deactivate route api", apiData.data);
            toast.error("Route deleted successfully")
            return apiData.data;
        } catch (error) {
            return thunkAPI.rejectWithValue(error);
        }
    }
);


